import { useEffect, useState } from 'react';
import { css } from '@eti/styles';
import { Icon } from '@eti/components';
import { AIR_HELP, CANCELLATION_GUARANTEE, CANCELLATION_INSIDE_EU, CANCELLATION_OUTSIDE_EU, SIMPLE_VISA } from '../../products';
import SimpleVisaLogo from '../../simple-visa/components/SimpleVisaLogo';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const airHelpIconsContainerStyles = css`
  margin-top: 16px;
`;
const airHelpIconStyle = css`
  width: 32px;
`;
const trustPilotLogoStyles = css`
  height: 32px;
  margin-left: 19px;

  [dir='rtl'] & {
    margin-left: unset;
    margin-right: 19px;
  }
`;
const solidInsuranceLogoStyles = css`
  display: block;
  height: 36px;
  margin-top: 16px;
`;
const fetchTrustPilotLogo = async () => {
  try {
    const trustPilotLogo = await import(`@eti/assets/logos/product-logos/trust-pilot.png`);
    return trustPilotLogo.default;
  } catch {
    return null;
  }
};
const fetchSolidInsuranceLogo = async () => {
  try {
    const solidInsuranceLogo = await import(`@eti/assets/logos/product-logos/solid-insurance.png`);
    return solidInsuranceLogo.default;
  } catch {
    return null;
  }
};
const ProductLogo = ({
  productName
}) => {
  const [trustPilotLogo, setTrustPilotLogo] = useState(null);
  const [solidInsuranceLogo, setSolidInsuranceLogo] = useState(null);
  useEffect(() => {
    if (productName === AIR_HELP.name) {
      const loadImages = async () => {
        const trustPilotLogoImg = await fetchTrustPilotLogo();
        setTrustPilotLogo(trustPilotLogoImg);
      };
      loadImages();
    } else if (productName === CANCELLATION_GUARANTEE.name || productName === CANCELLATION_INSIDE_EU.name || productName === CANCELLATION_OUTSIDE_EU.name) {
      const loadImages = async () => {
        const solidInsuranceLogoImg = await fetchSolidInsuranceLogo();
        setSolidInsuranceLogo(solidInsuranceLogoImg);
      };
      loadImages();
    }
  }, [productName]);
  const logos = {
    trustPilotLogo,
    solidInsuranceLogo
  };
  switch (productName) {
    case AIR_HELP.name:
      {
        return /*#__PURE__*/_jsxs("div", {
          className: airHelpIconsContainerStyles,
          children: [/*#__PURE__*/_jsx(Icon, {
            className: airHelpIconStyle,
            id: "airHelp"
          }), logos.trustPilotLogo && /*#__PURE__*/_jsx("img", {
            alt: "trust-pilot",
            className: trustPilotLogoStyles,
            src: logos.trustPilotLogo
          })]
        });
      }
    case CANCELLATION_GUARANTEE.name:
    case CANCELLATION_INSIDE_EU.name:
    case CANCELLATION_OUTSIDE_EU.name:
      {
        if (!logos.solidInsuranceLogo) {
          return null;
        }
        return /*#__PURE__*/_jsx("img", {
          alt: "solid-insurance",
          className: solidInsuranceLogoStyles,
          src: logos.solidInsuranceLogo
        });
      }
    case SIMPLE_VISA.name:
      {
        return /*#__PURE__*/_jsx(SimpleVisaLogo, {});
      }
    default:
      {
        return null;
      }
  }
};
export default ProductLogo;
//# sourceMappingURL=ProductLogo.js.map